module.exports = Object.freeze({
  INSERT_DEFAULT: 1,
  UPDATE_DEFAULT: 2,
  DELETE_DEFAULT: 3,
  UPDATE_RECURRING_SINGLE_EVENT: 4,
  DELETE_RECURRING_SINGLE_EVENT: 5,
  UPDATE_RECURRING_FUTURE_EVENTS: 6,
  DELETE_RECURRING_FUTURE_EVENTS: 7,
});
